import classes from "./GNCSupplementTiers.module.css";

type TierCategory = {
  title: string;
  color: string;
  lightColor: string;
  items: {
    essential: string[];
    advanced: string[];
    elite: string[];
  };
};

const TIERS: TierCategory[] = [
  {
    title: "LONGEVITY",
    color: "var(--secondary25)",
    lightColor: "#d1d9f4",
    items: {
      essential: ["Multivitamin", "Nootropic", "Joint Complex", "Omega"],
      advanced: ["NAD+", "Collagen", "Immune Advanced", "Glutathione"],
      elite: ["Resveratrol", "Probiotic", "Magnesium", "COQ-10"],
    },
  },
  {
    title: "PERFORMANCE",
    color: "var(--secondary33)",
    lightColor: "#ddd0e6",
    items: {
      essential: ["Creatine", "Nitric Oxide", "Amino Acids", "Hormone Booster"],
      advanced: ["Protein or Mass Gainer", "Pre-Workout", "Maca", "Hydration"],
      elite: ["DHEA", "Glutamine", "HMB", "ZMA"],
    },
  },
  {
    title: "WEIGHT LOSS",
    color: "var(--secondary15)",
    lightColor: "#cfe8e2",
    items: {
      essential: ["Thermogenic", "Detox", "CLA", "Carb/Fat Blocker"],
      advanced: ["Hormone Support", "Multivitamin", "Berberine", "Carnitine"],
      elite: ["Meal Replacement", "Diuretic", "Chromium", "Beets"],
    },
  },
];

const GNCSupplementTiers = () => {
  return (
    <div className={classes.container}>
      {TIERS.map((tier) => (
        <div key={tier.title} className={classes.tierBlock}>
          <div
            className={classes.tierHeader}
            style={{ backgroundColor: tier.color }}
          >
            {tier.title}
          </div>
          <div
            className={classes.columnsHeader}
            style={{ backgroundColor: tier.lightColor }}
          >
            <div className={classes.columnLabel}>Essential</div>
            <div className={classes.columnLabel}>Advanced</div>
            <div className={classes.columnLabel}>Elite</div>
          </div>
          <div className={classes.columnsBody}>
            <div className={classes.column}>
              {tier.items.essential.map((item) => (
                <div key={item} className={classes.item}>
                  {item}
                </div>
              ))}
            </div>
            <div className={classes.column}>
              {tier.items.advanced.map((item) => (
                <div key={item} className={classes.item}>
                  {item}
                </div>
              ))}
            </div>
            <div className={classes.column}>
              {tier.items.elite.map((item) => (
                <div key={item} className={classes.item}>
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GNCSupplementTiers;
